import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { SiteConfigProvider } from "@/context/SiteConfig";
import { AdminAuthProvider } from "@/context/AdminAuth";
import { Layout } from "@/components/Layout";
import { AuroraCursor } from "@/components/AuroraCursor";
import Home from "@/pages/Home";
import Rules from "@/pages/Rules";
import PenalCode from "@/pages/PenalCode";
import Jobs from "@/pages/Jobs";
import JobDetail from "@/pages/JobDetail";
import Businesses from "@/pages/Businesses";
import Gallery from "@/pages/Gallery";
import Streamers from "@/pages/Streamers";
import Staff from "@/pages/Staff";
import Upload from "@/pages/Upload";
import PlayerGuide from "@/pages/PlayerGuide";
import GuideDetail from "@/pages/GuideDetail";
import SceneHelper from "@/pages/SceneHelper";
import Tribes from "@/pages/Tribes";
import Lore from "@/pages/Lore";
import Gangs from "@/pages/Gangs";
import Support from "@/pages/Support";
import Admin from "@/pages/Admin";
import StaffPanel from "@/pages/StaffPanel";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SiteConfigProvider>
          <AdminAuthProvider>
            <AuroraCursor />
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/rules" element={<Rules />} />
                <Route path="/penal-code" element={<PenalCode />} />
                <Route path="/jobs" element={<Jobs />} />
                <Route path="/jobs/:slug" element={<JobDetail />} />
                <Route path="/businesses" element={<Businesses />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/streamers" element={<Streamers />} />
                <Route path="/staff" element={<Staff />} />
                <Route path="/upload" element={<Upload />} />
                <Route path="/guide" element={<PlayerGuide />} />
                <Route path="/guide/:slug" element={<GuideDetail />} />
                <Route path="/scene-helper" element={<SceneHelper />} />
                <Route path="/tribes" element={<Tribes />} />
                <Route path="/lore" element={<Lore />} />
                <Route path="/gangs" element={<Gangs />} />
                <Route path="/support" element={<Support />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/staff-panel" element={<StaffPanel />} />
              </Routes>
            </Layout>
            <Toaster theme="dark" position="bottom-right" />
          </AdminAuthProvider>
        </SiteConfigProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
